import { query, where, addDoc, collection, DocumentData,doc, getDoc, getDocs, onSnapshot, QuerySnapshot, Unsubscribe, updateDoc } from "firebase/firestore"
import { useRef } from "react";
import { db } from "../Firebase/Firebase"
import { Dispositivo, Medida, Sensor, Usuario } from "../Interfaces/Interfaces";

export const obtenerDispositivos = async()=>{
    const dispositivosRef = collection(db,"dispositivos");
    const dispositivosDocs = await getDocs(dispositivosRef);
    var dispositivos:Dispositivo[] = [];
    dispositivosDocs.forEach((d)=>{
        var dispositivo:Dispositivo = {
            id:d.id,
            nombre:d.data().nombre,
            estado:d.data().estado
        };
        dispositivos.push(dispositivo);
    });
    return dispositivos;
}

export const obtenerSensores = async(dispositivo?:Dispositivo,idDispositivo?:string)=>{
    var id="";
    if(dispositivo!=undefined){
        id = dispositivo.id;
    }else if(idDispositivo!=undefined){
        id = idDispositivo;
    }
    const sensoresRef = collection(db,"dispositivos",id,"sensores");
    const sensoresDocs = await getDocs(sensoresRef);
    var sensores:Sensor[] = [];
    sensoresDocs.forEach((d)=>{
        
        var sensor: Sensor = {
            id: d.data().id,
            tipo: d.data().tipo
        }
        sensores.push(sensor)
    })
    return sensores;
}
export const obtenerMedidas = (idDispositivo:string,idSensor:string,ref:React.Dispatch<React.SetStateAction<QuerySnapshot<DocumentData, DocumentData> | undefined>>)=>{
    var medidas:Medida[] = [];
  
    const medidasRef = collection(db,"dispositivos",idDispositivo,"sensores",idSensor,"medidas");
    const unsubscribe = onSnapshot(medidasRef, (querySnapshot) => {
        ref(querySnapshot)
    querySnapshot.forEach((doc) => {
        var medida:Medida = {
            id:doc.data().id,
            valor:doc.data().valor,
            fecha:doc.data().fecha
        }
      medidas.push(medida);
      
  });
  //ordenamiento
  
  medidas.sort((a, b) => {
    if(a.fecha.valueOf()>b.fecha.valueOf()){
        return -1;
    }else if(a.fecha.valueOf()<b.fecha.valueOf()){
        return 1;
    }
    return 0;
});

  return medidas;
}); 

}
export const registrarDispositivo = async(dispositivo:Dispositivo)=>{
    const dispositivosRef = collection(db,"dispositivos");
    const docRef = await addDoc(dispositivosRef, {
        nombre:dispositivo.nombre,
        estado:dispositivo.estado
      });
    
      return docRef.id;
}
export const cambiarEstadoDispositivo = async(dispositivo:Dispositivo)=>{
    const ref = doc(db,'dispositivos',dispositivo.id);
    const estado = dispositivo.estado==="encendido"?"apagado":"encendido";
    await updateDoc(ref,{
        estado
    });
}
export const validarUsuario = async(user:string,pass:string)=>{
    const ref = collection(db,'users');
    const q1 = query(ref, where("user", "==", user), where("pass", "==", pass));
    const qs = await getDocs(q1);
    const usuarios:Usuario[] = []
    qs.forEach((d)=>{
        const usuario:Usuario = {
            usuario:d.data().user,
            clave:d.data().pass,
            id:d.id,
        }
        usuarios.push(usuario)
    })
    return usuarios;

}
export const registrarUsuario = async(user:string,pass:string)=>{
    const usuariosRef = collection(db,"users");
    const docRef = await addDoc(usuariosRef, {
        user,
        pass
      });
    
      return docRef.id;
}
export const cambiarPass = async(u:Usuario,claveN:string)=>{
    const ref = doc(db,'users',u.id!);
    await updateDoc(ref,{
        pass:claveN
    });
}